<template>
  <div class="user-activity-dashboard">
    <div
      v-if="activity.activeUsers.length"
      class="user-activity-dashboard__active-users"
    >
      <!-- <div>Other users that are currently active on this page:</div> -->
      <div>
        <div v-for="user in activity.activeUsers" :key="user.Id">
          {{ user.username }} currently active on this page
        </div>
      </div>
    </div>
    <!-- <div v-else>No other users are currently active on this page.</div> -->
  </div>
</template>

<script setup lang="ts">
import { useActivityStore } from "@/stores/useActivityStore";

const activity = useActivityStore();
</script>

<style scoped lang="scss">
.user-activity-dashboard {
  &__active-users {
    margin-bottom: 1rem;
  }

  &__active-users-header {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
}
</style>
